import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { LocalStorage } from "./local-storage.service";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Observable, of, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CustomerConfigService extends HttpService {

  private url = environment.apiUrl + 'customerConfigurations';

  constructor(
    protected http: HttpClient,
    protected userService: UserService,
    protected router: Router,
    protected dialog: MatDialog,
    protected localStorage: LocalStorage,
    ) {
    super(http, userService, router, dialog, localStorage);
  }
  
  private gettingCustomerConfig: { [key: string]: boolean } = {};
  private customerConfigTimestamp: number = 0;
  /** KEYS_ARE_LIKE_THIS */
  private customerConfig: { [key: string]: string } = {};
  private customerConfig$: { [key: string]: Subject<string> } = {};

  private getCustomerConfigValue(configKey: string): Observable<string> {
    if (
      this.customerConfig[configKey] &&
      this.customerConfigTimestamp && 
      (new Date().getTime() - this.customerConfigTimestamp) < 1800000 //30 mins cache time
    ) {
      return of(this.customerConfig[configKey]);
    }
    if (!this.gettingCustomerConfig[configKey]) {
      this.gettingCustomerConfig[configKey] = true;
      this.customerConfig$[configKey] = new Subject();
      return this.GET(this.url + '/key/' + configKey).pipe(map(config => {
        this.customerConfig[configKey] = (config as CustomerConfig).configValue;
        this.customerConfigTimestamp = new Date().getTime();
        this.customerConfig$[configKey].next(this.customerConfig[configKey]);
        this.customerConfig$[configKey].complete();
        return this.customerConfig[configKey];
      }));
    } else {
      return this.customerConfig$[configKey];
    }
  }

  public clear() {
    this.gettingCustomerConfig = {};
    this.customerConfigTimestamp = 0;
    this.customerConfig = {};
    for (let key in this.customerConfig$) {
      if (!this.customerConfig$[key].closed) {
        this.customerConfig$[key].next(null);
        this.customerConfig$[key].complete();
      }
    }
    this.customerConfig$ = {};
  }

  public getCustomerConfig(configKey: string): Promise<string> {
    return this.getCustomerConfigValue(configKey).toPromise();
  }

  public getCustomerConfigBoolean(configKey: string): Promise<boolean> {
    return this.getCustomerConfigValue(configKey).pipe(map(value => [ 'TRUE', 'True', 'true' ].includes(value) ? true : false)).toPromise();
  }
}

interface CustomerConfig {
  id: number
  customerName: string
  configKey: string
  configValue: string
  createDate: string
  modifyDate: string
};